import React,{useState} from 'react';

///Styles
import {FaEllipsisV,FaSyncAlt} from 'react-icons/fa';
import { AiOutlineArrowLeft,AiOutlineFileExcel } from 'react-icons/ai';
import { Container } from './styles';


export function Header({back,refrash,handleDownloadCSV}){

    const [isOpenExcelButton, setIsOpenExcelButton] = useState(false);

    return(
        <Container>
            <h1 onClick={back}><AiOutlineArrowLeft/> <span>Empresas</span></h1>
           


            <div className='seeMore'>
                    <div className='icons-container'>
                        <FaSyncAlt onClick={refrash} className="icon"/>
                        <FaEllipsisV
                            onClick={() => setIsOpenExcelButton(!isOpenExcelButton)}
                        />
                    </div>

                    {
                        isOpenExcelButton &&
                        <div className='button-excel-container'>
                           <button onClick={handleDownloadCSV}>
                              <AiOutlineFileExcel />
                               Exportar Excel
                           </button>
                        </div>
                    }
                </div>
        </Container>
    )
}